// The email providers that can open a new account (see server/signup-email.ts for why).
// Shared so the sign-up form can say so before the player submits.
export const SIGNUP_DOMAINS: readonly string[] = Object.freeze([
  'gmail.com', 'googlemail.com',
  'outlook.com', 'hotmail.com', 'live.com', 'msn.com',
  'outlook.com.mx', 'hotmail.com.mx', 'outlook.com.ar', 'hotmail.com.ar', 'hotmail.es', 'outlook.es',
  'hotmail.co.uk', 'outlook.com.br', 'hotmail.com.br', 'hotmail.ca',
  'yahoo.com', 'yahoo.com.mx', 'yahoo.com.ar', 'yahoo.com.br', 'yahoo.es', 'yahoo.co.uk', 'yahoo.ca', 'ymail.com',
  'icloud.com', 'me.com', 'mac.com',
  'aol.com',
]);

/** Single addresses outside those providers that may still sign up: the game's own staff account (Cole 2026-10-27). */
export const SIGNUP_ADDRESSES: readonly string[] = Object.freeze(['admin@legendkin.com']);

/** The rules that need no database: provider and no "+" alias. Null when the address passes. */
export function signupEmailShapeProblem(email: string): string | null {
  const e = email.trim().toLowerCase();
  if (SIGNUP_ADDRESSES.includes(e)) return null;
  const domain = e.split('@')[1] ?? '';
  if (!SIGNUP_DOMAINS.includes(domain)) return 'Sign up with Gmail, Outlook, Hotmail, Yahoo or iCloud. Other email providers are not accepted.';
  if (e.split('@')[0].includes('+')) return 'Use your main email address, without a "+" part.';
  return null;
}
